<template lang="pug">
.box
  .box-body
    .alert.alert-info(v-if="category !== null && !onLoading('fetch-override-pricebook-products-count')")
      template(v-if="productsPoolCount > 0")
        | Adding {{ productsPoolCount }} products into pricebook
      template(v-else)
        | No products found in the selected category

    select(
      class="form-control c-select"
      v-model="category"
      @change="onCategoryChange"
    )
      option(:value="null") Select option
      option(
        v-for="category in categories"
        :value="category.id"
        :key="category.id")
          | {{ category.name }}

    override-values-form(:onChange="onOverrideValuesChange")
  .box-footer.b-t.text-right
    button.btn.m-r-sm(:disabled="onLoading('add-batch-override-entries')" @click="cancel") Cancel
    button.btn.primary(:disabled="!canSubmit" @click="createEntries") Setup
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OverrideValuesForm from './override-values-form';

export default {
    components: {
        OverrideValuesForm,
    },

    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
        onCancel: {
            type: Function,
            required: true,
        },
    },

    data: function() {
        return {
            category: null,
            overrideEntry: {
                price_adjustment_mode: 'none',
                price: '0',
            },
        };
    },

    computed: {
        canSubmit: function() {
            return (
                this.category !== null &&
                !this.onLoading('fetch-pricebook-products-count') &&
                this.productsPoolCount > 0
            );
        },
        ...mapGetters('category', ['categories']),
        ...mapGetters('override_pricebook', ['productsPoolCount']),
    },

    created() {
        this.getCategories();
    },

    methods: {
        onCategoryChange: function() {
            let params = {
                pricebookId: this.pricebookId,
                filters: {
                    category_id: this.category,
                },
            };
            this.getOverridePricebookProductsCount(params);
        },
        onOverrideValuesChange: function(val) {
            this.overrideEntry = val;
        },
        cancel: function() {
            this.onCancel();
        },
        async createEntries() {
            try {
                await this.addBatchEntries({
                    pricebookId: this.pricebookId,
                    filters: { category_id: this.category },
                    params: this.overrideEntry,
                });
                this.showToastrSuccess();
                this.getOverridePricebook(this.pricebookId);
            } catch (e) {
                this.showApiError(e);
            }
        },
        ...mapActions('category', ['getCategories']),
        ...mapActions('override_pricebook', [
            'getOverridePricebook',
            'getOverridePricebookProductsCount',
            'addBatchEntries',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch/category-filter.vue